// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__VJhzv","header__card":"card_header__card___dDD_","img__header":"card_img__header__50zoh"};